import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from "dayjs";

const generateCustomerRegistrationAuditExcel = async (data, endDate) => {
  if (!Array.isArray(data) || data.length === 0) {
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Customer Registration Audit");

  const formattedDate = endDate
    ? (dayjs.isDayjs(endDate)
        ? endDate.format("YYYY-MM-DD")
        : dayjs(endDate).isValid()
          ? dayjs(endDate).format("YYYY-MM-DD")
          : "")
    : "";

  const titleText = formattedDate
    ? `Customer Registration Audit Report - ${formattedDate}`
    : "Customer Registration Audit Report";

  worksheet.getRow(1).height = 25;
  const totalColumns = data.length * 8 - 1;
  worksheet.mergeCells(1, 1, 1, totalColumns);
  const titleCell = worksheet.getCell(1, 1);
  titleCell.value = titleText;
  titleCell.alignment = { horizontal: "center", vertical: "middle" };
  titleCell.font = { bold: true, size: 14 };

  worksheet.getRow(2).height = 10;

  const branchHeaderSet = [
    "Classification",
    "Count",
    "Rate%",
    "30th day of the month nearest the audit date",
    "Rate%",
    "As of the audit date",
    "Rate%",
  ];

  let startCol = 1;
  data.forEach((branch) => {
    const endCol = startCol + 6;
    worksheet.mergeCells(3, startCol, 3, endCol);
    const cell = worksheet.getCell(3, startCol);
    cell.value = branch.branchName;
    cell.alignment = { horizontal: "center", vertical: "middle" };
    cell.font = { bold: true };
    startCol = endCol + 2;
  });

  let headerRow = [];
  data.forEach((branch, index) => {
    headerRow = headerRow.concat(branchHeaderSet);
    if (index < data.length - 1) {
      headerRow.push("");
    }
  });
  worksheet.getRow(4).values = headerRow;

  const classifications = ["Male", "Female", "collection"];
  classifications.forEach((cls) => {
    const row = [];
    data.forEach((branch, index) => {
      let value = "";
      if (cls === "Male") value = branch.maleCount;
      else if (cls === "Female") value = branch.femaleCount;
      else if (cls === "collection") value = branch.maleCount + branch.femaleCount;
      row.push(cls, value, "", "", "", "", "");
      if (index < data.length - 1) {
        row.push("");
      }
    });
    worksheet.addRow(row);
  });

  worksheet.columns.forEach((col, index) => {
    const colNum = index + 1;
    let isGapColumn = false;
    let currentCol = 1;
    for (let i = 0; i < data.length - 1; i++) {
      currentCol += 7;
      if (colNum === currentCol) {
        isGapColumn = true;
        break;
      }
      currentCol += 1;
    }
    col.width = isGapColumn ? 5 : 20;
  });

  worksheet.views = [{ state: "frozen", ySplit: 4 }];

  worksheet.eachRow((row, rowNum) => {
    row.eachCell((cell, colNum) => {
      let isGapColumn = false;
      let currentCol = 1;
      for (let i = 0; i < data.length - 1; i++) {
        currentCol += 7;
        if (colNum === currentCol) {
          isGapColumn = true;
          break;
        }
        currentCol += 1;
      }
      if (!isGapColumn && rowNum > 2) {
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      }
      cell.alignment = { horizontal: "center", vertical: "middle" };
    });
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const fileName = formattedDate
    ? `CustomerRegistrationAudit_${formattedDate}.xlsx`
    : "CustomerRegistrationAudit.xlsx";

  saveAs(blob, fileName);
};

export default generateCustomerRegistrationAuditExcel;
